import { Controller, useFormContext } from 'react-hook-form'
import { CurecallToggle } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'
import { TChatbotGeneralFormValues } from '../chatbot-form.type'
import { ChatbotAutoEndField } from './chatbot-auto-end-field.component'
import { ChatbotAutoRelaunchField } from './chatbot-auto-relaunch-field.component'

export function ChatbotTogglesFields() {
  const { t } = useTranslation()
  const { control } = useFormContext<TChatbotGeneralFormValues>()

  return (
    <div className="c-flex c-flex-col c-gap-4 [&>div>div]:c-w-max">
      <ChatbotAutoEndField />

      <Controller
        control={control}
        name="schedule.avoidHolidays"
        render={({ field }) => (
          <CurecallToggle
            leftLabel={t('pages.configuration.followups.chatbot.general-form.avoid-holidays')}
            isEnabled={field.value}
            onChange={field.onChange}
            tooltipContent={t('pages.configuration.followups.chatbot.general-form.avoid-holidays-tooltip')}
            tooltipPosition="right"
          />
        )}
      />

      <ChatbotAutoRelaunchField />
    </div>
  )
}
